import { render, staticRenderFns } from "./NotIdea.vue?vue&type=template&id=b3b281e6&"
import script from "./NotIdea.vue?vue&type=script&lang=js&"
export * from "./NotIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports